import React from 'react';
import { Link } from 'gatsby';

import { TArticle, useLatestFourNewsItems } from '@hooks';

import { NewsPreviewContainer } from './styles';
import { ConstLink } from '../const-link';

interface INewsPreviewArgs extends React.HTMLAttributes<HTMLDivElement> {
  items?: TArticle[];
}

const NewsPreview = ({ items, className, ...rest }: INewsPreviewArgs) => {
  const latestFourItems = useLatestFourNewsItems();

  return (
    <NewsPreviewContainer
      className={[
        'news_preview',
        items ? 'news_preview--custom-items' : null,
        className,
      ].join(' ')}
      {...rest}
    >
      <h2 className="news_preview__heading">Read our latest news</h2>
      <div className="news_preview__grid">
        {(items || latestFourItems).map(({ id, title, content, url }) => (
          <article key={id} className="news_preview__item">
            <div>
              <h3>{title}</h3>
              <hr />
              <p>
                {content
                  .trim()
                  .replaceAll('**', '')
                  .replaceAll('__', '')
                  .substring(0, 180)}{' '}
                [..]
              </p>
            </div>
            <div>
              <Link to={url}>Read more</Link>
            </div>
          </article>
        ))}
      </div>
      {!items && (
        <ConstLink to="/news" className="news_preview__read_more">
          Read more
        </ConstLink>
      )}
    </NewsPreviewContainer>
  );
};

export { NewsPreview };
